// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "shared/components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import Footer from "app/layout/Footer";

// Data
import PowerBIEmbed from "./components/PowerBIEmbed";

function Conciliacion() {
  return (
    <DashboardLayout>
      <MDBox pt={5} pb={3}>
        <Grid container spacing={6}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <PowerBIEmbed />
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Conciliacion;
